import { Link, useLocation } from 'react-router-dom';
import { base44 } from '@/api/base44Client';
import { useQuery } from '@tanstack/react-query';
import { Compass, Home, Trophy, Info } from 'lucide-react';
import SiteHeader from '@/components/site/SiteHeader';
import SiteFooter from '@/components/site/SiteFooter';


export default function PageNotFound({}) {
    const location = useLocation();
    const pageName = location.pathname.substring(1);

    const { data: authData, isFetched } = useQuery({
        queryKey: ['user'],
        queryFn: async () => {
            try {
                const user = await base44.auth.me();
                return { user, isAuthenticated: true };
            } catch (error) {
                return { user: null, isAuthenticated: false };
            }
        }
    });

    return (
        <div className="tf-public flex min-h-screen flex-col">
            <SiteHeader />
            <main className="flex flex-1 items-center justify-center px-4 py-16">
                <div className="w-full max-w-md text-center">
                    <span className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-tf-blue/10 text-tf-blue" aria-hidden>
                        <Compass className="h-8 w-8" />
                    </span>
                    <p className="mt-4 text-sm font-semibold text-tf-blue">Error 404</p>
                    <h1 className="mt-1 text-[28px] font-bold leading-tight">Page not found</h1>
                    <p className="mt-2 text-tf-muted">
                        We couldn't find <span className="font-medium text-tf-ink">"{pageName}"</span>. The link may be old or mistyped.
                    </p>

                    {/* Admin note */}
                    {isFetched && authData.isAuthenticated && authData.user?.role === 'admin' && (
                        <div className="mt-6 flex items-start gap-3 rounded-tf-card border border-tf-line bg-tf-card p-4 text-left shadow-tf-soft">
                            <Info className="mt-0.5 h-4 w-4 shrink-0 text-tf-warning" aria-hidden />
                            <div className="space-y-1">
                                <p className="text-sm font-semibold">Admin note</p>
                                <p className="text-sm text-tf-muted">This could mean that the AI hasn't implemented this page yet. Ask it to implement it in the chat.</p>
                            </div>
                        </div>
                    )}

                    <div className="mt-8 flex flex-wrap justify-center gap-2">
                        <Link to="/" className="inline-flex h-11 items-center gap-2 rounded-tf-control bg-tf-blue px-4 text-sm font-semibold text-white hover:bg-tf-blue-deep">
                            <Home className="h-4 w-4" aria-hidden />Go home
                        </Link>
                        <Link to="/tournaments" className="inline-flex h-11 items-center gap-2 rounded-tf-control border border-tf-line bg-tf-card px-4 text-sm font-semibold hover:border-tf-blue/40">
                            <Trophy className="h-4 w-4" aria-hidden />Find a tournament
                        </Link>
                    </div>
                </div>
            </main>
            <SiteFooter />
        </div>
    )
}
